const PropTypes = require('prop-types');
const React = require('react');

class ScrollTarget extends React.Component {
  constructor() {
    super();
    this.scrollToTop = this.scrollToTop.bind(this);
  }

  scrollToTop() {
    if (this.shouldScroll()) {
      window.scrollTo(0, this.clientTop + window.scrollY);
    }
  }

  shouldScroll() {
    if (this.props.onlyScrollUp) {
      return this.clientTop < 0;
    }
    return true;
  }

  get clientTop() {
    return this.refs.scrollTarget.getBoundingClientRect().top;
  }

  render() {
    return (
      <div>
        <div className="offset-anchor-wrapper">
          <div className="offset-anchor scrollTarget" ref="scrollTarget"></div>
        </div>
        <div>
          {this.props.children}
        </div>
      </div>
    );
  }
}

ScrollTarget.propTypes = {
  children: PropTypes.node,
  onlyScrollUp: PropTypes.bool,
};

module.exports = ScrollTarget;



// WEBPACK FOOTER //
// ./javascripts/components/shared/scroll_target.jsx